import { useMutation, useQuery } from "@tanstack/react-query"
import { Button, InputNumber, message, Space, Checkbox, Tooltip } from "antd"
import StickyTable from "../../../table/StickyTable"   // tog'a #4695/#4703: hamma jadvalda sarlavha va «Итого» qotadi
import { request } from "../../../../utils/config"   // s91
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  UPDATE_CURRENCY_RATE,
  FETCH_CBU_RATE,
  SET_AUTO_FETCH_CBU,
} from "../../../../rest-api/mutations/currencyRate"
import { GET_CURRENCY_RATE } from "../../../../rest-api/queries/currencyRate"
import { SyncOutlined } from "@ant-design/icons"

export default function CurrencyRate() {
  const { t } = useTranslation()
  const [currencyRate, setCurrencyRate] = useState<number | undefined>(0)
  const [autoFetch, setAutoFetch] = useState<boolean>(false)

  const {
    isLoading: gLoading,
    data: gData,
    error: gError,
    refetch,
  } = useQuery(["GET_CURRENCY_RATE"], GET_CURRENCY_RATE)
  // s91: tarix (oxirgi 30)
  const history = useQuery(["RATE_HISTORY"], () => request({ url: "Helpers/RateHistory", params: { take: 30 } }).then((r) => r.data || []))

  const {
    mutate: updateCurrencyRate,
    isLoading: uLoading,
    error: uError,
  } = useMutation(UPDATE_CURRENCY_RATE, {
    onSuccess: () => {
      history.refetch(); message.success(t("success"))
      refetch()
    },
    onError: () => {
      message.error(t("error"))
    },
  })

  const {
    mutate: fetchCbuRate,
    isLoading: fLoading,
  } = useMutation(FETCH_CBU_RATE, {
    onSuccess: (data: any) => {
      history.refetch(); message.success(`Курс успешно получен из ЦБ РУз: ${data?.uzs || data?.UZS || ""} сум`)
      refetch()
    },
    onError: () => {
      message.error(t("cbRateError"))
    },
  })

  const {
    mutate: setAutoFetchMutation,
    isLoading: sLoading,
  } = useMutation(SET_AUTO_FETCH_CBU, {
    onSuccess: (data: any) => {
      message.success(t("success"))
      refetch()
    },
    onError: () => {
      message.error(t("error"))
    },
  })

  useEffect(() => {
    if (gData?.uzs !== undefined && gData?.uzs !== null) {
      setCurrencyRate(gData?.uzs)
    }
    if ((gData as any)?.autoFetchCBU !== undefined) {
      setAutoFetch(Boolean((gData as any)?.autoFetchCBU))
    }
  }, [gData])

  function handleUpdate() {
    if (!currencyRate) return
    updateCurrencyRate({
      uzs: currencyRate,
    })
  }

  function handleAutoFetchToggle(checked: boolean) {
    setAutoFetch(checked)
    setAutoFetchMutation(checked)
  }

  const isLoading = uLoading || gLoading || fLoading || sLoading

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      <Space size={10} wrap>
        <InputNumber
          style={{ minWidth: "160px" }}
          min={1}
          value={currencyRate}
          onChange={(value) => setCurrencyRate(value ?? undefined)}
          disabled={isLoading}
          placeholder={t("currencyRate")}
          formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
        />
        <Button
          onClick={() => handleUpdate()}
          type="primary"
          loading={uLoading}
          danger={!!uError || !!gError}
          disabled={isLoading}
        >
          {t("save")}
        </Button>
        <Tooltip title={t("cbRateHint")}>
          <Button
            icon={<SyncOutlined spin={fLoading} />}
            onClick={() => fetchCbuRate()}
            loading={fLoading}
            disabled={isLoading}
          >
            Курс ЦБ (API)
          </Button>
        </Tooltip>
      </Space>

      <div>
        <Checkbox
          checked={autoFetch}
          onChange={(e) => handleAutoFetchToggle(e.target.checked)}
          disabled={isLoading}
        >
          Автоматически обновлять курс доллара по ЦБ РУз
        </Checkbox>
      </div>
      {/* s91 (tog'a 2026-09-09, §10): kurs o'zgarishlari tarixi — avval bitta qator ustiga yozilib, tarix yo'q edi */}
      <div style={{ marginTop: 14 }}>
        <div style={{ fontWeight: 600, marginBottom: 6 }}>{t("rateHistoryTitle", "История курса")}</div>
        <StickyTable size="small" pagination={false} rowKey="id" dataSource={history.data || []}
          columns={[
            { title: t("date"), dataIndex: "inserted", width: 150, render: (v: string) => v ? new Date(v).toLocaleString("ru-RU") : "" },
            { title: t("exchangeRate"), dataIndex: "uzs", width: 110, align: "right" as const, render: (v: number) => Number(v).toLocaleString("ru-RU") },
            { title: "←", dataIndex: "prevUZS", width: 110, align: "right" as const, render: (v: number) => v ? Number(v).toLocaleString("ru-RU") : "—" },
            { title: t("source", "Источник"), dataIndex: "source", width: 90, render: (v: string) => v === "cbu" ? "ЦБ" : "вручную" },
            { title: t("user", "Кто"), dataIndex: "user" },
          ]} />
      </div>
    </div>
  )
}